import { useAtom } from 'jotai';
import { useGetHeurekaResourceAvailabilitySuspense } from '../api/generated';
import { selectedOrganizationAtom } from '../state/selectedOrganization';
import { HeurekaConnectionRequiredError } from './errors';

export function useHeurekaResourceAvailability() {
  const [selectedPractice] = useAtom(selectedOrganizationAtom);
  if (!selectedPractice.isConnectedToHeureka) {
    throw new HeurekaConnectionRequiredError();
  }
  const { data } = useGetHeurekaResourceAvailabilitySuspense(selectedPractice.id);
  return data;
}
